import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useUserQuery } from '../lib/queries';

export default function UserPage() {
  const params = useParams();
  const { t } = useTranslation();

  const userQuery = useUserQuery(params.id!);

  if (!userQuery.data) return null;

  return (
    <main className="grid gap-4 w-700 mx-auto">
      <h1 className="text-hero font-bold col-span-2">{t('user.title')}</h1>

      <span className="font-semibold">{t('user.name')}</span>
      <span>{userQuery.data.user.name}</span>

      <span className="font-semibold">{t('user.createdAt')}</span>
      <span className="grid">
        <span>{new Date(userQuery.data.user.createdAt).toLocaleTimeString()}</span>
        <span>{new Date(userQuery.data.user.createdAt).toLocaleDateString()}</span>
      </span>

      <span className="font-semibold">{t('user.role')}</span>
      {t(`user.${userQuery.data.user.role}`)}

      <span className="font-semibold">{t('common.email')}</span>
      {userQuery.data.user.email}
    </main>
  );
}
